import React from 'react';
import styled from 'styled-components';
import CircularEmailIcon from '../../assets/icons/circular-email.svg';
import CustomButton from '../CustomButton/CustomButton';
import { default as MondayButton } from 'monday-ui-react-core/dist/Button';
import { useTranslation } from 'react-i18next';

const VerifyEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;

  .circular__check {
    margin-bottom: 22px;
  }

  .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;

    text-align: center;
    letter-spacing: -1px;
  }

  p {
    text-align: center;
    word-break: break-word;

    @media only screen and (max-width: 768px) {
      width: 90%;
      .email {
        display: none;
      }
    }

    @media only screen and (min-width: 768px) {
      width: 80%;
    }

    @media only screen and (min-width: 1024px) {
      width: 70%;
    }
  }

  button {
    margin-top: 38px;
    margin-bottom: 54px;
  }
`;

const VerifyEmailDialogBody = ({ verifyEmail, isLoading }) => {
  const { t } = useTranslation();

  return (
    <VerifyEmailContainer>
      <img className="circular__check" src={CircularEmailIcon} alt="close" />
      <h1 className="title">{t('Verify Your Email')}</h1>
      <p>{t('Click below to verify your email address')}</p>
      {isLoading ? (
        <MondayButton loading={isLoading} />
      ) : (
        <CustomButton onClick={verifyEmail}>{t('Verify')}</CustomButton>
      )}
    </VerifyEmailContainer>
  );
};

export default VerifyEmailDialogBody;
